/**
 * WbStepper — aantal-kiezer met grote −/+ tikvlakken (52 px) en het getal
 * mono ertussen. Voor Inpakken, Ondertapijt en Kleed toevoegen.
 */

import clsx from 'clsx';

export interface WbStepperProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  stap?: number;
  label?: string;
  disabled?: boolean;
  className?: string;
}

export function WbStepper({ value, onChange, min = 0, max = Number.POSITIVE_INFINITY, stap = 1, label, disabled, className }: WbStepperProps) {
  const knop = 'wb-focus min-h-tap w-14 shrink-0 flex items-center justify-center font-wb-heading font-bold text-2xl text-wb-inkt bg-wb-vlak active:bg-wb-gedempt disabled:opacity-40 select-none';
  return (
    <div className={clsx('inline-flex items-stretch border-wb border-wb-rand rounded-wb overflow-hidden', className)} role="group" aria-label={label}>
      <button type="button" className={clsx(knop, 'border-r-wb border-wb-rand')} onClick={() => onChange(Math.max(min, value - stap))} disabled={disabled || value - stap < min} aria-label="Minder">
        −
      </button>
      <span className="min-w-[56px] px-2 flex items-center justify-center font-mono text-xl font-semibold text-wb-inkt bg-wb-vlak tabular-nums" aria-live="polite">
        {value}
      </span>
      <button type="button" className={clsx(knop, 'border-l-wb border-wb-rand')} onClick={() => onChange(Math.min(max, value + stap))} disabled={disabled || value + stap > max} aria-label="Meer">
        +
      </button>
    </div>
  );
}
